import { Route, Switch, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { DeparturesView } from './departures.view';

/**
 * Routeur pour la gestion des départs
 * 
 * Ce routeur gère la navigation pour :
 * - Vue des départs (/departures)
 * 
 * Logique métier :
 * - Routage simple vers la vue des départs
 * - Pas de sous-routes complexes
 * - Composant unique pour tous les utilisateurs
 * 
 * @returns Composant React du routeur des départs
 */
export const DeparturesRouter = () => {
  let { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <DeparturesView />
        </Route>
      </Switch>
    </div>
  );
};
